module.exports = __webpack_public_path__ + "static/flags/BX-87366ff54eed341800f45f8c3221822d.gif";